import { Modal, ModalProps } from 'react-bootstrap';
import classNames from 'classnames';

export const ModalV2 = ({ className, ...props }: ModalProps) => (
  <Modal {...props} className={classNames('modal-v2', className)} />
);

ModalV2.Header = Modal.Header;
ModalV2.Title = Modal.Title;
ModalV2.Body = Modal.Body;
ModalV2.Footer = Modal.Footer;
